<template>
  <div class="home">
    <div class="icons">
      <HomeLink v-for="module in modules" :module="module" :key="module[0]"/>
    </div>
  </div>
</template>

<script>
import HomeLink from '@/components/HomeLink'
export default {
  name: 'home',
  components: {
    HomeLink
  },
  computed: {
    modules(){
      return Object.entries(this.$modules)
    }
  },
  created(){
    console.log(this.$i18n)
  }
}
</script>

<style lang="scss" scoped>

  .icons {
    width: 74vw;
    margin: 0 auto;
  }

  @media screen and (min-width: 768px) and (max-width: 1280px) {
    .icons {
      width: 72vw;
    }
  }

  @media screen and (min-width: 1024px) {
    .icons {
      margin-top: vh(9);
      width: 72.2vw;
    }
  }
  
</style>
